module.exports = __webpack_public_path__ + "img/gate_2_1.0eb942eb.png";